<template>
  <tbody>
    <tr v-for="(leadAct, idx) in listingreferrals"
        :key="idx"
        @click="navigateToLead(leadAct.agent.key, leadAct.lead.key)"
        class="ut-border-b ut-border-t ut-border-neutral-020 ut-cursor-default"
        v-gaEvent="{ category: 'Listing Referral',
                     action: 'Click to single deal page',
                     label: `AID=${leadAct.agent.id} | LeadId=${leadAct.lead.id}`}">
      <td :title="leadAct.lead.fullAddress" data-oa-name="full-address" class="ut-py-8 ut-capitalize ut-overflow-hidden ut-whitespace-no-wrap address">
        {{ leadAct.lead.fullAddress }}
      </td>
      <td class="ut-px-3 ut-whitespace-no-wrap ut-capitalize">
        {{ leadAct.lead.firstName }}&nbsp;{{ leadAct.lead.lastName }}
      </td>
      <td class="ut-px-3 ut-whitespace-no-wrap">
        {{ formateDate(leadAct.agent.referralDate) }}
      </td>
      <td class="ut-px-3 ut-whitespace-no-wrap">
        {{ formateDate(leadAct.lead.stageListed) }}
      </td>
      <td :title="leadAct.agent.displayName" class="ut-px-3">
        <avatar v-if="leadAct.agent.imageUrl" size="sm" :imgSrc="leadAct.agent.imageUrl" />
        <avatar-placeholder v-else class="ut-p-4" />
      </td>
      <td class="ut-px-3 ut-whitespace-no-wrap payment-status" v-html="leadAct.agent.paymentStatus">
     
      </td>
    </tr>
  </tbody>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { LeadAgentLeadStageTypeId, LeadAgentLeadStageType } from '@/Mapper/LeadAgentLeadStageType';
import Pill from '@/components/Pill.vue';
import Avatar from '@/components/Avatar.vue';
import AvatarPlaceholder from '@/components/AvatarPlaceholder.vue';

export default {
  name: 'ListingReferralTableBody',
  components: {
    Pill,
    Avatar,
    AvatarPlaceholder,
  },
  props: {
    listingreferrals: { required: true },
  },
  computed: {
    ...mapState({
      user: state => state.userStore.user,
    }),
    ...mapGetters('userStore', [
      'isPrincipal',
      'isManager',
    ]),
  },
  methods: {
    formateDate(date) {
      return this.$helpers.formatDateNormal(date);
    },
    navigateToLead(agentKey, leadKey) {
      if (this.isPrincipal) {
        this.$router.push({
          path: `/${agentKey}/lead/${leadKey}${!!this.user && !!this.user.key ? `/${this.user.key}` : ''}`,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
  .address {
    text-overflow: ellipsis;
    max-width: 230px;
  }

  tr {
      @apply ut-cursor-pointer;

      &:hover {
            @apply ut-shadow-md;
        }
  }

  .payment-status {
    line-height: 20px;
  }

</style>
